import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class KPIService {
  
    answers:any = {}
    invalidFields:any[] = [];

    constructor(

    ) { }

    
    updateInvalidFields(id:number, val:any) {
        if(val === 0) val = "0";
        if(Math.sign(Number(val)) === -1) val = "0";

        let value = val ? val.toString() : "";
        if(value !== "" && this.invalidFields.indexOf(id) >= 0) this.invalidFields.splice(this.invalidFields.indexOf(id), 1);
        if(value === "" && this.invalidFields.indexOf(id) == -1) this.invalidFields.push(id);
    }
    
}
